// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { WorkingHoursFragmentDoc } from '../../cms/WorkingHours.fragment.generated';
export const FooterItemWorkingHoursFragmentDoc = `
    fragment footerItemWorkingHours on FooterColumnItemWorkingHours {
  workingHours(locale: $locale) {
    ...workingHours
  }
}
    `;